import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(anchor => {
      anchor.addEventListener('click', this.handleClick.bind(this))
    })
  }

  handleClick(event) {
    let href = event.currentTarget.getAttribute('href')
    if (href === '#') return

    // Normalize "/#section" to "#section" for same-page scrolling
    if (href.startsWith('/#')) href = href.substring(1)

    const target = document.querySelector(href)
    if (target) {
      event.preventDefault()
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }
}
